module.exports = __webpack_public_path__ + "static/img/4.80f61e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/eng/4.png
// module id = fbT+
// module chunks = 0